import { Space } from "antd";
import classes from './MainScreen.module.scss';
import Container from "../Container/Container";
import main1 from '../../../assets/images/main1.png';
import main2 from '../../../assets/images/main2.png';
import main3 from '../../../assets/images/main3.png';
import { useTranslation } from "react-i18next";

const MainScreen = () => {
  const { t } = useTranslation();

  return (
    <div className={classes['container']}>
      <Container style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <Space direction='vertical' className={classes.text} size={40}>
          <h1>{t('pages.main.welcome.title')}</h1>
          <p style={{color: 'white'}}>
            {t('pages.main.welcome.subtitle')}
          </p>
        </Space>
        <div className={classes.images}>
          <div className={classes.image1}>
            <img src={main1} alt='' />
          </div>
          <div className={classes.image2}>
            <img src={main2} alt='' />
          </div>
          <div className={classes.image3}>
            <img src={main3} alt='' />
          </div>
        </div>
      </Container>
    </div>
)
}

export default MainScreen;
